<ng-container *transloco="let tr; prefix: 'permissions'; scope: 'permissions'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{'permissions.title' | transloco}}</nz-page-header-title>
      <nz-page-header-subtitle>{{'permissions.subTitle' | transloco}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'permissions.button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>
  <!--<nz-skeleton *ngIf="isLoading" [nzActive]="true"></nz-skeleton>-->
  <nz-collapse nzBordered="false">
    <nz-collapse-panel nzHeader="Фильтры" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col [nzSm]="6">
          <nz-select [(ngModel)]="containerClass" (ngModelChange)="clearContainerId()" nzShowSearch nzAllowClear nzPlaceHolder="Выберите тип">
            <nz-option *ngFor="let op of containerClassOptions" [nzValue]="op" [nzLabel]="op"></nz-option>
          </nz-select>
        </div>
        <div nz-col [nzSm]="8">
          <hx-store-select *ngIf="containerClass === 'Store'" [(ngModel)]="containerId" (ngModelChange)="applyFilters()"></hx-store-select>
          <hx-user-select *ngIf="containerClass === 'User'" [(ngModel)]="containerId" (ngModelChange)="applyFilters()"></hx-user-select>
          <hx-org-select *ngIf="containerClass === 'Organization'" [(ngModel)]="containerId" (ngModelChange)="applyFilters()"></hx-org-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #permissionsTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="key" [nzSortOrder]="columnSortOrderMap.get('key') || null" [nzSortFn]="true" [nzSortPriority]="1">{{'permissions.column.key' | transloco}}</th>
      <th nzColumnKey="containerId">{{'permissions.column.containerId' | transloco}}</th>
      <th nzColumnKey="containerClass">{{'permissions.column.containerClass' | transloco}}</th>
      <th nzColumnKey="active">{{'permissions.column.active' | transloco}}</th>
      <th nzColumnKey="activeDate">{{'permissions.column.activeDate' | transloco}}</th>
      <th nzColumnKey="excludeUserIds">{{'permissions.column.excludeUserCount' | transloco}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of list">
      <td>{{ ('enum.PermissionKey.' + data.key) | transloco }}</td>
      <td>{{ data.containerId }}</td>
      <td>{{ data.containerClass }}</td>
      <td><nz-switch (click)="toggleActive(data)" [nzControl]="true" [nzLoading]="isLoading.permissions[data.id]" [(ngModel)]="data.active"></nz-switch></td>
      <td>{{ data.startDate | date: 'dd.MM.yyyy HH:mm' }} - {{ data.endDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>{{ data.excludeUserIds.length }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <nz-dropdown-menu #storesFilterMenu>
    <div class="cp__filter ant-table-filter-dropdown">
      <nz-checkbox-group [(ngModel)]="storesFilter.options"></nz-checkbox-group>

      <div class="ant-table-filter-dropdown-btns">
        <button (click)="resetFilter(storesFilter)" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>
        <button (click)="applyFilter(storesFilter)" nz-button nzType="primary" nzSize="small">OK</button>
      </div>
    </div>
  </nz-dropdown-menu>

</ng-container>
